module.exports = __webpack_public_path__ + "img/369.b7b5585f.png";